import { InjectionToken } from '@angular/core';

export const QT_INTLS = new InjectionToken<QtIntl[]>('QT_INTLS');

export abstract class QtIntl {
  /**
   * Update translation codes and emit change event.
   *
   * @param translations Object with all translations for current language.
   */
  abstract updateTranslations(translations: any): any;

  /**
   * Get translation codes to fetch from ws.
   *
   */
  abstract getTranslations(): string[];
}
